import { Link } from "react-router-dom";
import { latestTicker } from "@/mocks/ticker";

export default function TickerStrip() {
  const doubled = [...latestTicker, ...latestTicker];
  return (
    <section className="bg-secondary-900 text-secondary-50 overflow-hidden">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-content mx-auto flex items-center gap-4 py-3">
          <span className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-500 text-secondary-950 text-xs font-medium whitespace-nowrap">
            <i className="ri-flashlight-fill"></i>
            正在发生
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex items-center gap-8 marquee-track w-max">
              {doubled.map((item, index) => (
                <Link
                  key={`${item.id}-${index}`}
                  to={`/article/${item.id}`}
                  className="text-xs md:text-sm text-secondary-100/90 hover:text-accent-300 transition-colors whitespace-nowrap"
                >
                  <span className="text-accent-400 mr-1.5">·</span>
                  {item.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}